import { define } from '../../define.js';
import { LuxenStory } from './story.js';
export * from './story.js';
define('story', LuxenStory);
